// @core/api/endpoints/secret/create_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePolicyRequest,
  SecretPolicyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Create access policy
 * Creates a new path-based access policy. Policies define capabilities (create, read, update, delete, list, sudo, deny) for specific secret paths.
 */
export async function CreatePolicy(
  data: CreatePolicyRequest,
  options?: RequestOptions
): Promise<SecretPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/policies`;
  const requestOptions = options;
  return client.post<SecretPolicyResponse>(requestPath, data, requestOptions);
}
